import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {TableService} from "./table.service";

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  private toastVisibility = new BehaviorSubject<any>({});
  public toastVisible$ = this.toastVisibility.asObservable();

  constructor() { }

  showMessage(type: string, message: string, _timer: number = 3500): void {
    this.toastVisibility.next({type, message, _timer});
  }
}
